<app-menu-accordion [closeOthers]="true" [showArrows]="showArrows" *ngFor="let menuId of currentLevelList">
  <app-menu-accordion-group [activeChain]="activeChain" [type]="type" [ids]="currentLevelList" [id]="menuData[menuId]?.page" [link]="menuData[menuId]?.slug" [heading]="menuData[menuId]?.name" [hasChildren]="menuData[menuId]?.children?.length">
    <app-hierarchical-menu
      [activeChain]="activeChain"
      [menuData]="menuData"
      [ids]="menuData[menuId]?.children"
      [isChild]="true">
      <ng-template let-menuId>
        <ng-template [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{$implicit: menuId}"></ng-template>
      </ng-template>
    </app-hierarchical-menu>
  </app-menu-accordion-group>
</app-menu-accordion>
